import * as images from "./images";

export const mocktail = [
  // {
  //   img: images.moro,
  //   nome: "Shanghai",
  //   ricetta: {
  //     it: "Versione analcolica dell'Hong Kong",
  //     en: "Non alcohol version of Hong Kong",
  //   },
  // },
  {
    img: images.corto,
    nome: "NOGRONI",
    ricetta: {
      it: "Versione analcolica del Negroni con Tanqueray 0.0",
      en: "Non alcohol version of Negroni with Tanqueray 0.0",
    },
  },
  {
    img: images.lungo,
    nome: "0.07onic",
    ricetta: {
      it: "Versione analcolica del Gin Tonic con Tanqueray 0.0",
      en: "Non alcohol version of Gin Tonic with Tanqueray 0.0",
    },
  },
  // {
  //   img: images.flute,
  //   nome: "Fake 75",
  //   ricetta: {
  //     it: "Versione analcolica del French 75",
  //     en: "Non alcohol version of Frenc 75",
  //   },
  // },
  {
    img: images.lungo,
    nome: "Sacramento",
    ricetta: {
      it: "Versione analcolica del 50 Shades",
      en: "Non alcohol version of 50 Shades",
    },
  },
  {
    img: images.vino, //! Bicchiere Vino
    nome: "Zero Spritz",
    ricetta: {
      it: "Versione analcolica dell' Aperol Spritz",
      en: "Non alcohol version of Aperol Spritz",
    },
  },
  {
    img: images.lungo,
    nome: "Paloma Light",
    ricetta: {
      it: "Versione analcolica del Paloma",
      en: "Non alcohol version of Paloma",
    },
  },
  // {
  //   img: images.b5,
  //   nome: "Santo Domingo",
  //   ricetta: {
  //     it: "Anans, Cioccolato bianco & Cocco",
  //     en: "Pineapple, White chocolate & Cocco",
  //   },
  // },
  // {
  //   img: images.lungo,
  //   nome: "Melbourne",
  //   ricetta: {
  //     it: "Anguria, Sour, Soda",
  //     en: "Watermelon, Sour, Soda",
  //   },
  // },
  // {
  //   img: images.b1,
  //   nome: "Brighton",
  //   ricetta: {
  //     it: "Mela, Menta, Fiori di sanbuco, Cetriolo, Limone",
  //     en: "Apple, Mint, Elderflower, Cucumber, Fresh lemon juice",
  //   },
  // },
  // {
  //   img: images.b1,
  //   nome: "Ica",
  //   ricetta: {
  //     it: "Melograno, Limone, Ananas",
  //     en: "Pomegranate, Lemon, Pineapple",
  //   },
  // },
];
